<div class="app-login" role="main">
  <div class="u_overflow-hidden h-100">
    <div class="tv-room">
      <div
        class="tv-panel aligner-item--top"
        [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')' }"
      >
        <div class="tv-position">
          <div class="tv-frame">
            <img
              #previewElement
              src="/images/sign-up/preview1.jpg"
              [alt]="initialSlideAlt"
            />
            <div class="slideshow-controls">
              <button
                type="button"
                class="slideshow-control-btn"
                (click)="toggleSlideShow()"
                [attr.aria-label]="
                  isSlideShowPaused ? 'Resume slideshow' : 'Pause slideshow'
                "
                [attr.aria-pressed]="!isSlideShowPaused"
                [title]="
                  isSlideShowPaused ? 'Resume slideshow' : 'Pause slideshow'
                "
              >
                <mat-icon
                  [svgIcon]="isSlideShowPaused ? 'play' : 'pause'"
                  aria-hidden="true"
                ></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="scroll-panel">
      <div id="auth-panel" class="auth-panel">
        <div class="align-center rise-logo">
          <img
            src="https://widgets.risevision.com/apps/logos/rise-logo.svg"
            alt="Rise Vision logo"
          />
        </div>
        <div ui-view></div>
      </div>
    </div>
  </div>
</div>
